module.exports = __webpack_public_path__ + "static/media/cq_nuovo_messaggio.885e3c25.svg";